










import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppEditLocation extends Vue {
  onEditLocation() {
    this.$store.commit("EDIT_LOCATION_CLICK");
  }
}
